import React, { useState, useEffect } from 'react';
import { Form, Formik, Field } from 'formik';
import * as moment from 'moment';
import { connect, useDispatch, useSelector } from 'react-redux';
import { FORMAT, BIDFORMAT } from 'web/components/utils/dateOfBirthValidation';
import AlertModal from 'web/components/AlertModal';
import TextArea from 'web/components/form-elements/TextArea';
import { returnAuthorization, pickupRequest } from 'redux/actions/myClaims';
import { stateLabelValues, stateConvert } from 'web/components/utils/stateAbbreviation';
import Spinner from 'web/components/Spinner';

import {
  getInitialValues,
  getRegisterSchema,
} from 'web/components/utils/claimAcceptanceUtils';

import { useHistory } from 'react-router-dom';
import Button from 'web/components/Button';
import DropDown from 'web/components/DropDown';
import Select from 'web/components/form-elements/Select';

import DatePicker from 'web/components/form-elements/DatePicker';

import TextInput from 'web/components/form-elements/TextInput';
import NumberInput from 'web/components/form-elements/NumberInput';

import RadioButton from 'web/components/form-elements/RadioButton';

import {
  claimDispute
} from 'redux/actions/myOrders';
import { claimRequest } from 'redux/actions/myClaims';
import CloseIcon from 'web/assets/images/CloseIcon.png';

import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { constants } from 'os';
import styled from 'styled-components'
import styles from './acceptModal.module.scss';
import { fetchLanguageContentNew } from 'redux/actions/language';

import { Container, Body, RequestDate, RecurrencePattern, Heading, BoxWrapper, ModalContainer, RangeofRecurrence, PatternWrapper, RadioData, RadioWrapper } from './acceptModalStyled'

export default ({ isOpen, toggle, title, content, link, postType, callBackAccept, acceptPopupResponse, acceptRadioState }) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
  const [pageLoader, setPageLoader] = useState(false)


  const [authorizationResponse, setAuthorizationResponse] = useState();

  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('/');
  const [titleGet, titleSet] = useState();

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  const toggleModal = () => setModal(!modal);
  const validationSchemaArray = getRegisterSchema();

  const [dateObjState, setDateObjState] = useState();
  const token = localStorage.getItem('token');
  const accountType = localStorage.getItem('accountType')
  const redirectLink = (link) => {
    if (link === 'manageAccount') {
      window.location.reload(false);
    } else {
      if (link !== '/') {
        history.push(link);
      }
    }
    toggle(!isOpen)
  }

  useEffect(() => {
    if (languageContentNew?.Resolution_Center_Page) setPageLanguageContents(languageContentNew.Resolution_Center_Page)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  useEffect(() => {
    callAuthorization()
  }, [acceptPopupResponse]);

  const callAuthorization = async () => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      let data = {
        id: acceptPopupResponse.id,
        orderId: acceptPopupResponse.orderId,
      }
      let response = await dispatch(returnAuthorization(data, token));
      if (response.status === 'SUCCESS') {
        setAuthorizationResponse(response.payload)
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
    }
  }
  const callPickup = async (props, setFieldValue) => {
    if (token === null) {
      setModalContent('Please Sign In again.');
      setModalLink('/');
      toggleModal();
    } else {
      setPageLoader(true)
      let issueType = acceptPopupResponse.issueType
      let commentSet = ''
      // pickup means exchange option, away means pickup option, other means Customer to Keep Pallets
      if (acceptRadioState === 'pickUp') {
        if (issueType === 'QUANTITY') {
          if (acceptPopupResponse.deliveryType === 'PICKUP') commentSet = "Redeliver/Pickup Missing Quantity"
          else commentSet = "Redeliver/Pickup Missing Quantity"
        } else if (issueType === 'QUALITY') {
          commentSet = "Exchange Pallets"
        } else {
          commentSet = "Exchange Damaged Pallets & Supply Missing Pallets"
        }
      } else if (acceptRadioState === 'away') {
        if (issueType === 'QUANTITY') {
          commentSet = "Pickup Pallets & Issue Credit to Customer"
        } else if (issueType === 'QUALITY') {
          commentSet = "Pickup Pallets & Issue Credit to Customer"
        } else {
          commentSet = "Pickup Damaged Pallets & Issue Credit for All Damaged & Missing Pallets"
        }
      } else {
        if (issueType === 'QUANTITY') {
          commentSet = "“Issue Credit to Customer for Missing Quantity Amount"
        } else if (issueType === 'QUALITY') {
          commentSet = "Customer to Keep Pallets & Issue Credit to Customer"
        } else {
          commentSet = "Customer Keeps Damaged Pallets. Issue Credit for All Damaged Pallets & Missing Pallets"
        }
      }

      let isPickedUpIssuesPallet;
      let resolutionTypeChosen = 'CREDIT'
      if (acceptRadioState === 'pickUp') {
        isPickedUpIssuesPallet = false;
        resolutionTypeChosen = 'EXCHANGE'
      } else if (acceptRadioState === 'away') {
        isPickedUpIssuesPallet = true
      } else {
        isPickedUpIssuesPallet = false
      }

      let data = {
        claimId: acceptPopupResponse.id,
        orderId: acceptPopupResponse.orderId,
        returnInstruction: commentSet,
        resolutionMessage: commentSet,
        returnPickUpDate: moment(props.values.pickUpDate).format(BIDFORMAT),
        isPickedUpIssuesPallet: isPickedUpIssuesPallet, // when seller want to pick up pallets  otherwise false
        comment: acceptRadioState === 'other' ? props.values.comments : props.values.returnInstructions,
        resolutionType: resolutionTypeChosen,
        claimStatus: 'RESOLVED'
      }
      let response = await dispatch(pickupRequest(data, token));
      if (response.status === 'SUCCESS') {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
        titleSet(pageLanguageContents?.AcceptModal[26]?.AddUser)
      } else {
        if (response.statusCode === 401) {
          history.push('./sign-in')
          window.location.reload(false);
        } else {
          setModalContent(response.message);
          setModalLink('');
          toggleModal();
        }
      }
      setPageLoader(false)
    }
  }

  return (
    <ModalContainer>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        backdrop={'static'}
        centered={true}
        fullscreen='fullscreen'
        className={`claimResolutionModalClass ${styles.recurranceModal}`}
      >
        <div className=''>
          <div className={styles.header}>
            <Button handleClick={() => {
              toggle(!isOpen)
            }}>
              <img src={CloseIcon} className="closeIcon" alt="close-icon" />
            </Button>
            <h3></h3>
          </div>
          <ModalBody>
            {authorizationResponse && <Formik
              initialValues={getInitialValues(authorizationResponse)}
              validationSchema={validationSchemaArray[0](acceptRadioState)}
              onSubmit={(values) => {
              }}>
              {(props) => {
                const {
                  isValid,
                  dirty,
                  values,
                  errors,
                  touched,
                  setFieldValue,
                } = props;
                return (
                  <>
                    <Form>
                      <Container>
                        <Body>
                          {(loaderVisible || pageLoader) && <Spinner />}
                          <div className={styles.Wrapper}>
                            <div className={styles.formContainer}>
                              <div className={styles.form}>
                                <div>
                                  <div className='mb-3'>
                                    <h6 style={{ marginBottom: '15px' }} className={styles.headingName}>{pageLanguageContents?.AcceptModal[1]?.ResolutionConfirmation}</h6>
                                    {acceptRadioState === 'pickUp' && <>
                                      {acceptPopupResponse.issueType === 'QUANTITY' &&
                                        <>
                                          <h5 className={styles.headingName}>{acceptPopupResponse.deliveryType === 'PICKUP' ? pageLanguageContents?.ClaimContents[49]?.ExchangePalletsQuantityPickup : pageLanguageContents?.ClaimContents[44]?.ExchangePalletsQuantity}</h5>
                                          <p className={styles.headingName}>{pageLanguageContents?.AcceptModal[27]?.ExchangePalletBlurb}</p>
                                        </>
                                      }
                                      {acceptPopupResponse.issueType === 'QUALITY' &&
                                        <>
                                          <h5 className={styles.headingName}>{pageLanguageContents?.ClaimContents[0]?.ExchangePallets}</h5>
                                          <p className={styles.headingName}>{pageLanguageContents?.AcceptModal[27]?.ExchangePalletBlurb}</p>
                                        </>
                                      }
                                      {acceptPopupResponse.issueType === 'BOTH' &&
                                        <>
                                          <h5 className={styles.headingName}>{pageLanguageContents?.ClaimContents[46]?.ExchangePalletsBoth}</h5>
                                          <p className={styles.headingName}>{pageLanguageContents?.AcceptModal[27]?.ExchangePalletBlurb}</p>
                                        </>
                                      }
                                    </>}

                                    {acceptRadioState === 'away' && <>
                                      {acceptPopupResponse.issueType === 'QUANTITY' &&
                                        <>
                                          <h5 className={styles.headingName}>{pageLanguageContents?.ClaimContents[1]?.PickupPallets}</h5>
                                        </>
                                      }
                                      {acceptPopupResponse.issueType === 'QUALITY' &&
                                        <>
                                          <h5 className={styles.headingName}>{pageLanguageContents?.ClaimContents[1]?.PickupPallets}</h5>
                                        </>
                                      }
                                      {acceptPopupResponse.issueType === 'BOTH' &&
                                        <>
                                          <h5 className={styles.headingName}>{pageLanguageContents?.ClaimContents[47]?.PickupPalletsBoth}</h5>
                                        </>
                                      }
                                    </>
                                    }

                                    {acceptRadioState === 'other' && <>
                                      {acceptPopupResponse.issueType === 'QUANTITY' &&
                                        <>
                                          <h5 className={styles.headingName}>{pageLanguageContents?.ClaimContents[45]?.KeepPalletsQuantity}</h5>
                                        </>
                                      }
                                      {acceptPopupResponse.issueType === 'QUALITY' &&
                                        <>
                                          <h5 className={styles.headingName}>{pageLanguageContents?.ClaimContents[2]?.KeepPallets}</h5>
                                        </>
                                      }
                                      {acceptPopupResponse.issueType === 'BOTH' &&
                                        <>
                                          <h5 className={styles.headingName}>{pageLanguageContents?.ClaimContents[48]?.KeepPalletsBoth}</h5>
                                        </>
                                      }
                                    </>
                                    }
                                  </div>

                                  {authorizationResponse.comments && accountType === "Buyer" && <RowGroup>
                                    <div className="row mx-0 bgGray">
                                      <div className='col-6'>
                                        <p>{pageLanguageContents?.AcceptModal[4]?.IssueDescription} {authorizationResponse.comments || ''}</p>
                                      </div>
                                    </div>
                                  </RowGroup>}
                                  <RowGroup>
                                    <div className="row mx-0 bgGray">
                                      <div className='col-6'>
                                        <div className='mb-2'>
                                          <p className="bold">{pageLanguageContents?.AcceptModal[5]?.SupplierAddress}</p>
                                        </div>
                                        <div>
                                          <p>{pageLanguageContents?.AcceptModal[6]?.Name} {authorizationResponse.shipFrom && authorizationResponse.shipFrom.name || ''}</p>
                                          <p>{pageLanguageContents?.AcceptModal[7]?.Address} {authorizationResponse.shipFrom && authorizationResponse.shipFrom.line1 || ''} {authorizationResponse.shipFrom.line2 || ''}</p>
                                          <p>{pageLanguageContents?.AcceptModal[8]?.City_State} {authorizationResponse.shipFrom && authorizationResponse.shipFrom.city.trim() || ''}/{stateConvert(authorizationResponse.shipFrom.state) || authorizationResponse.shipFrom.state || ''}</p>
                                        </div>
                                      </div>
                                      <div className='col-6'>
                                        <div className='mb-2'>
                                          <p className="bold">{acceptPopupResponse.deliveryType === 'PICKUP' ? 'Pick Up Location' : pageLanguageContents?.AcceptModal[9]?.Consignee}</p>
                                        </div>
                                        <div>
                                          <p>{pageLanguageContents?.AcceptModal[6]?.Name} {authorizationResponse.shipTo && authorizationResponse.shipTo.name || ''}</p>
                                          <p>{pageLanguageContents?.AcceptModal[7]?.Address} {authorizationResponse.shipTo && authorizationResponse.shipTo.line1 || ''} {authorizationResponse.shipTo.line2 || ''}</p>
                                          <p>{pageLanguageContents?.AcceptModal[8]?.City_State} {authorizationResponse.shipTo && authorizationResponse.shipTo.city.trim() || ''}/{stateConvert(authorizationResponse.shipTo.state) || authorizationResponse.shipTo.state || ''}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </RowGroup>
                                  <RowGroup>
                                    <div className="row mx-0 bgGray">
                                      <div className='col-6'>
                                        <div className='mb-2'>
                                          <p className="bold">{pageLanguageContents?.AcceptModal[10]?.OrderInfo}</p>
                                        </div>

                                        <div>
                                          <p>{pageLanguageContents?.AcceptModal[11]?.PONumber} {authorizationResponse.poNumber && authorizationResponse.poNumber || 'NA'}</p>
                                          <p>{pageLanguageContents?.AcceptModal[13]?.Condition} {authorizationResponse.order && authorizationResponse.order.orderDetails && authorizationResponse.order.orderDetails.material},&nbsp;
                                            {authorizationResponse.order && authorizationResponse.order.orderDetails && authorizationResponse.order.orderDetails.material === 'OTHER' ? 'NA' : authorizationResponse.order.orderDetails.condition && authorizationResponse.order.orderDetails.condition.length > 0 && authorizationResponse.order.orderDetails.condition[0]}
                                            {authorizationResponse?.order?.orderDetails?.newConditionType && (authorizationResponse?.order?.orderDetails?.newConditionType === "HARDWOOD" ? '(HW)' : '(SW)')}</p>
                                          {/* <p>{pageLanguageContents?.AcceptModal[14]?.Grade} {authorizationResponse.order && authorizationResponse.order.orderDetails && (authorizationResponse.order.orderDetails.material === 'OTHER' || authorizationResponse.order.orderDetails.material === 'PLASTIC') ?
                                            <>{'NA'}, {authorizationResponse.order && authorizationResponse.order.orderDetails && authorizationResponse.order.orderDetails.dimension && `${authorizationResponse.order.orderDetails.dimension.length} x ${authorizationResponse.order.orderDetails.dimension.width} x ${authorizationResponse.order.orderDetails.dimension.height}`}, {'NA'}</>
                                            :
                                            <>{authorizationResponse.commodity && authorizationResponse.commodity.commodityName}, {authorizationResponse.grade && authorizationResponse.grade.gradeName}, {authorizationResponse.grade && authorizationResponse.grade.sizeWiseGrad ? authorizationResponse.grade.sizeWiseGrad : 'NA'}</>}</p> */}
                                          <p>{pageLanguageContents?.AcceptModal[14]?.Grade} {authorizationResponse.order && authorizationResponse.order.orderDetails && (authorizationResponse.order.orderDetails.material === 'OTHER' || authorizationResponse.order.orderDetails.material === 'PLASTIC') ?
                                            <>{'NA'}, {authorizationResponse.order && authorizationResponse.order.orderDetails && authorizationResponse.order.orderDetails.dimension && `${authorizationResponse.order.orderDetails.dimension.length} x ${authorizationResponse.order.orderDetails.dimension.width} x ${authorizationResponse.order.orderDetails.dimension.height}`}, {'NA'}</>
                                            :
                                            <>
                                              {authorizationResponse.commodity && authorizationResponse.commodity.commodityName},{authorizationResponse.grade && authorizationResponse.grade.gradeName} {authorizationResponse.order.orderDetails.dimension.height &&
                                                authorizationResponse.order.orderDetails.dimension.length +
                                                "x" +
                                                authorizationResponse.order.orderDetails.dimension.width +
                                                "x" +
                                                authorizationResponse.order.orderDetails.dimension.height},{authorizationResponse.grade && authorizationResponse.grade.sizeWiseGrad ? authorizationResponse.grade.sizeWiseGrad : 'NA'}
                                              {/* {authorizationResponse.commodity && authorizationResponse.commodity.commodityName}, {authorizationResponse.grade && authorizationResponse.grade.sizeWiseGrad ? authorizationResponse.grade.sizeWiseGrad : `${authorizationResponse.order.orderDetails.dimension.length} x ${authorizationResponse.order.orderDetails.dimension.width} x ${authorizationResponse.order.orderDetails.dimension.height}`}, {authorizationResponse.grade && authorizationResponse.grade.gradeName ?authorizationResponse.grade.gradeName : "NA" } */}
                                            </>
                                          }</p>


                                          {authorizationResponse.pickUpDate && <p>Requested Pickup Date : {moment(authorizationResponse.pickUpDate).format(FORMAT) || ''}</p>}
                                          {authorizationResponse.deliveryDate && <p>Requested Delivery Date : {moment(authorizationResponse.deliveryDate).format(FORMAT) || ''}</p>}

                                          {authorizationResponse.rescheduleOrder ? <>
                                            <p>{pageLanguageContents?.AcceptModal[15]?.RescheduleDate}{accountType === "Buyer" ? moment(authorizationResponse.rescheduleOrder.buyerRescheduledDate).format(FORMAT) :
                                              moment(authorizationResponse.rescheduleOrder.sellerRescheduledDate).format(FORMAT)} </p>
                                          </> : <>
                                            {authorizationResponse.order && authorizationResponse.order.sellerDeliveryDate && <p>
                                              {authorizationResponse.pickUpDate ? 'Actual Pickup Date : ' : 'Actual Delivery Date : '}
                                              {/* {pageLanguageContents?.AcceptModal[16]?.ExpectedDeliveryDate} */}
                                              {moment(authorizationResponse.order.sellerDeliveryDate).format(FORMAT) || ''}</p>}
                                          </>}

                                          <p>{pageLanguageContents?.AcceptModal[12]?.Qty} {authorizationResponse.quantity && authorizationResponse.quantity || ''}</p>
                                          <p>Unit Cost: ${acceptPopupResponse.pricePerPallet?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ''}</p>
                                          <p>Total Cost: ${authorizationResponse.totalCost?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                        </div>
                                      </div>
                                      <div className='col-6'>
                                        <div className='mb-2'>
                                          <p className="bold">{pageLanguageContents?.AcceptModal[17]?.ClaimDetail}</p>
                                        </div>
                                        <div>
                                          <p>{pageLanguageContents?.AcceptModal[18]?.IssueQuantity} &nbsp;
                                            {acceptPopupResponse.issueType === 'BOTH' && `[${acceptPopupResponse.totalPalletQuality} Quality], [${acceptPopupResponse.totalPalletQuantity} Missing Qty] `}
                                            {acceptPopupResponse.issueType === 'QUANTITY' && `${acceptPopupResponse.totalPalletQuantity} Missing Qty`}
                                            {acceptPopupResponse.issueType === 'QUALITY' && `${acceptPopupResponse.totalPalletQuality} Quality`}</p>

                                          <p>{pageLanguageContents?.AcceptModal[19]?.CreditIssued} ${authorizationResponse.claimedCost?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",") || ''}</p>
                                        </div>
                                      </div>
                                    </div>
                                  </RowGroup>
                                  {acceptRadioState !== 'other' &&
                                    <RowGroup>
                                      <div className="row mx-0 bgGray">
                                        <div className='col-lg-4 col-sm-12'>
                                          <div className='mb-2'>
                                            {acceptRadioState === 'pickUp' ?
                                              <>
                                                {acceptPopupResponse.deliveryType === 'PICKUP' ?
                                                  <p className="bold">Pickup Date</p> :
                                                  <p className="bold">Delivery Date</p>}
                                              </>
                                              :
                                              <p className="bold">{pageLanguageContents?.AcceptModal[21]?.PickUpDate}</p>}
                                          </div>
                                          <div>
                                            <DatePicker
                                              name='pickUpDate'
                                              placeholderText=''
                                              type='claimDatesDisabled'
                                              selectedDate={dateObjState}
                                              response={authorizationResponse}
                                              callBackFun={(date) => {
                                                setDateObjState(date)
                                              }}
                                            />
                                          </div>
                                        </div>


                                        <div className='col-lg-8 col-sm-12'>
                                          <div className='mb-2'>
                                            {acceptRadioState === 'pickUp' ? <p className="bold">{pageLanguageContents?.AcceptModal[22]?.DeliveryNotes}<span className="star">*</span></p> :
                                              <p className="bold">{pageLanguageContents?.AcceptModal[23]?.PickUpNotes}<span className="star">*</span></p>}
                                          </div>
                                          <div>
                                            <TextArea
                                              name='returnInstructions'
                                              maxLength='200'
                                              showErrorMessages={true}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </RowGroup>
                                  }
                                  {acceptRadioState === 'other' && <RowGroup>
                                    <div className="row mx-0 bgGray">
                                      <div className='col-12'>
                                        <div className='mb-2'>
                                          <p className="bold">{pageLanguageContents?.AcceptModal[24]?.Comments}<span className="star">*</span></p>
                                        </div>
                                        <div>
                                          <TextArea name='comments' placeholder='' maxLength='200' />
                                        </div>
                                      </div>
                                    </div>
                                  </RowGroup>
                                  }
                                  <ActionBtn>
                                    {acceptRadioState === 'pickUp' &&
                                      <Button
                                        type='app-green-button'
                                        disabled={!(isValid && dirty)}
                                        handleClick={() => {
                                          callPickup(props, setFieldValue)
                                        }}>
                                        {pageLanguageContents?.AcceptModal[25]?.Confirm}
                                      </Button>}
                                    {acceptRadioState === 'other' &&
                                      <Button
                                        type='app-green-button'
                                        disabled={!(isValid && dirty)}
                                        handleClick={() => {
                                          callPickup(props, setFieldValue)
                                        }}>
                                        {pageLanguageContents?.AcceptModal[25]?.Confirm}
                                      </Button>}
                                    {acceptRadioState === 'away' &&
                                      <Button
                                        type='app-green-button'
                                        disabled={!(isValid && dirty)}
                                        handleClick={() => {
                                          callPickup(props, setFieldValue)
                                        }}>
                                        {pageLanguageContents?.AcceptModal[25]?.Confirm}
                                      </Button>}
                                  </ActionBtn>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Body>
                      </Container>
                    </Form>
                  </>
                )
              }}
            </Formik>
            }
          </ModalBody>

          <AlertModal
            isOpen={modal}
            toggle={toggleModal}
            title={titleGet}
            content={modalContent}
            callBackAlert={() => {
              toggle(!isOpen)
              if (acceptRadioState === 'pickUp') {
                let myOrderSelectedPageObj = {
                  myOrderSelectedPage: 1,
                }
                dispatch({ type: 'MYORDER_PAGINATION', payload: myOrderSelectedPageObj })
                let obj = { selectedTab: "PENDING", expanded: "sideBar" }
                dispatch({ type: 'ORDERS', payload: obj })
                history.push('/my-orders')
              } else {
                callBackAccept('Resolved')
              }
            }}
            link={modalLink}
          />
        </div>
      </Modal>
    </ModalContainer>
  );
};


const RowGroup = styled.div`
  text-align: left;
  margin: 10px 0;
  .bold {
    font-family: "latobold";
    color: #000 !important;
    font-size:17px !important;
  }
  .bgGray {
    background: #d8d8d833;
    border-radius: 8px;
    padding: 6px 0px;
  }
`
const ActionBtn = styled.div`
 display: flex;
     margin: 15px 0;
    align-items: center;
    justify-content: flex-end;
    grid-gap: 15px;
    > button {
      height: 38px;
    width: 90px;
    }

`